import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InfoForModal } from '../../ma-tickers.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-card-dropdown-modal',
  templateUrl: './card-dropdown-modal.component.html',
  styleUrls: ['./card-dropdown-modal.component.scss'],
})
export class CardDropdownModalComponent implements OnInit {

  @Input() label: string;
  @Input() infoForModal: InfoForModal;
  @Input() type: string;
  @Output() itemEmitter = new EventEmitter<InfoForModal>();
  showModal = false;
  modalParamForm: ModalParamGroup;
  baseParams: InfoForModal;
  isBaseSelected = true;

  constructor(
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.baseParams = {
      minValue: this.infoForModal?.minValue,
      maxValue: this.infoForModal?.maxValue,
    };
    this.modalParamForm = this.fb.group({
      minValue: new FormControl<number>(this.infoForModal?.minValue),
      maxValue: new FormControl<number>(this.infoForModal?.maxValue),
    });
    this.isBaseSelected = true;
  }

  toggleModal(): void {
    this.modalParamForm.controls.minValue.patchValue(this.infoForModal.minValue);
    this.modalParamForm.controls.maxValue.patchValue(this.infoForModal.maxValue);
    this.showModal = !this.showModal;
  }

  applyChanges(isReset: boolean): void {
    if (isReset) {
      this.modalParamForm.controls.minValue.patchValue(this.baseParams.minValue);
      this.modalParamForm.controls.maxValue.patchValue(this.baseParams.maxValue);
    }
    this.infoForModal.minValue = this.modalParamForm.value.minValue;
    this.infoForModal.maxValue = this.modalParamForm.value.maxValue;
    this.isBaseSelected = this.isAll();
    this.itemEmitter.emit(this.infoForModal);
    this.showModal = !this.showModal;
  }

  closeImgClick(): void {
    this.modalParamForm.controls.minValue.patchValue(this.baseParams.minValue);
    this.modalParamForm.controls.maxValue.patchValue(this.baseParams.maxValue);
    this.infoForModal.minValue = this.modalParamForm.value.minValue;
    this.infoForModal.maxValue = this.modalParamForm.value.maxValue;
    this.isBaseSelected = this.isAll();
    this.itemEmitter.emit(this.infoForModal);
    if (this.showModal) {
      this.showModal = !this.showModal;
    }
  }

  isAll(): boolean {
    return this.infoForModal.minValue === this.baseParams.minValue &&
      this.infoForModal.maxValue === this.baseParams.maxValue;
  }
}

type ModalParamGroup = FormGroup<{
  minValue: FormControl<number>;
  maxValue: FormControl<number>;
}>;
